import { usePostHog } from "posthog-js/react";
import { useRef } from "react";

export function useTrackViewedWords() {
  const posthog = usePostHog();
  const once = useRef(false);

  const trackViewedWords = () => {
    if (once.current) return;
    once.current = true;
    posthog.capture("viewed_words");
  };

  return trackViewedWords;
}